import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import {
  REQUEST,
  previewSegmentSuccess,
  previewSegmentFailure,
} from '../../actions/segments/preview';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

/**
 * Worker saga for previewing segment data.
 *
 * Hits the unified `/segment/preview` endpoint, which accepts
 * EITHER a saved segment id OR an inline config (used during the
 * Create Segment page preview where the segment hasn't been saved
 * yet). Both paths run through the same SegmentDataset / ClickHouse
 * SQL pipeline on the backend.
 */
function* previewSegment(action) {
  try {
    const headers = getLocalUser();
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    headers['Content-Type'] = 'application/json';

    // `action.source` is one of "segment_id" or "config".
    const sourceType = action.source;
    const requestPayload = {
      page: action.payload.page || 1,
      page_size: action.payload.page_size || 100,
    };
    if (sourceType === 'segment_id') {
      requestPayload.segment_id = action.payload.segment_id;
    } else if (sourceType === 'config') {
      requestPayload.config = action.payload.config;
    }

    const response = yield call(
      axios.post,
      `${config.API_URL}/segment/preview`,
      requestPayload,
      { headers },
    );

    yield put(previewSegmentSuccess(response.data));
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = extractErrorMessage(error);

    yield put(ErrorAction(error));
    yield put(previewSegmentFailure(errorMessage));
    return { success: false, error: errorMessage };
  }
}

export function* watch() {
  yield takeLatest(REQUEST, previewSegment);
}
